import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../src/Responsive.css";
import "./communitypage.css";
import Spinner from "react-bootstrap/Spinner";
import Swal from "sweetalert2";
import {
  validateEmail,
  validateFirstName,
  validateLastName,
  validateNoNumbersOrSpecialChars,
} from "../../../utils/validation";
import { fetchGames } from "../../../store/reducers/upcomingLakersGameSlice";
import { fetchBoxScores } from "../../../store/reducers/previousScoreBoxSlice";
import TopStories from "../Community/TopStories/TopStories";
import PlayingGames from "../Community/PlayingGames/PlayingGames";
import axios from "axios";
import "react-international-phone/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import messages from "../../../constants/messages";
import lineImage from "../../../assets/images/line-art-large.png";
import { signUpNewsLetter, resetNewsLetterState } from "../../../store/reducers/newsLetterSlice";

const style = {
  backgroundImage: `url(${lineImage})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  overflow: 'hidden',
};

const CommunityPageMain = () => {

  const dispatch = useDispatch();
   const { loading:loadindNews, error:errorNews, success, message } = useSelector((state) => state?.signUpNewsLetter);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isLive, setIsLive] = useState(false);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorWalletAddress, setErrorWalletAddress] = useState("");
  const [loadingData, setLoading] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [errorAcceptance, setErrorAcceptance] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [isPhoneUsed, setIsPhoneUsed] = useState(false);

  const { preScores, preloading, error } = useSelector(
    (state) => state?.previousScore
  );

  const { games, loading, status } = useSelector((state) => state?.fetchGames);
  const first_upcoming_game = games?.upcoming_response?.[0];
  const previous_games = games?.previous_response;
  const reversedPreviousGames = Array.isArray(previous_games)
    ? [...previous_games.filter(game => game.time === "Final")].reverse()
    : [];
  const date = new Date(Date.now()).toISOString().split("T")[0];

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchBoxScores());
      dispatch(fetchGames(date));
    }
  }, [date, status, dispatch]);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    if (isNaN(date.getTime())) {
      return new Intl.DateTimeFormat("en-US", options).format(new Date());
    }
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  const isValidDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return false;
    } else {
      return true;
    }
  };

  const isValidTime = (timeString) => {
    const regex = /^(?:[01]?[0-9]|2[0-3]):([0-5]?[0-9])$/;

    return regex.test(timeString);
  };


  useEffect(() => {
    const checkLiveStatus = () => {
      const liveStatus = preScores?.is_live_data;
      if (liveStatus && !isLive) {
        setIsLive(true);
      } else if (!liveStatus && isLive) {
        setIsLive(false);
        dispatch(fetchGames(date));
      }
    };

    checkLiveStatus();
    const intervalId = setInterval(() => {
      checkLiveStatus();
    }, 5000);
    return () => clearInterval(intervalId); 
  }, [dispatch, preScores.is_live_data, isLive, date]);


  useEffect(() => {
    if (isLive) {
      dispatch(fetchBoxScores());
      const boxScoreIntervalId = setInterval(() => {
        dispatch(fetchBoxScores());
      }, 5000); 
      return () => clearInterval(boxScoreIntervalId); 
    }
  }, [isLive, dispatch]);



  function formatDate(isoDateString) {
    const date = new Date(isoDateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    if (isNaN(date.getTime())) {
      return new Date().toLocaleDateString("en-US", options);
    }
    return date.toLocaleDateString("en-US", options);
  }

  // Format the new time back to a string
  const currentTime = new Date();
  const matchTime = new Date(first_upcoming_game?.status);
  const timeDifference = matchTime - currentTime;
  const hoursDifference = timeDifference / (1000 * 60 * 60);

  const handleChange = async (value) => {
    setErrorPhone("");
    const formattedValue = value.startsWith("+") ? value : `+${value}`;
    setPhone(formattedValue);
    const isValid = validatePhoneNumber(formattedValue);
    setIsValid(isValid);
    if (!isValid) {
      setErrorPhone(messages.errors.invalidPhone);
    } else {
      setErrorPhone("");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_ENDPOINT_URL}/users/isPhoneNumberUsed/${formattedValue}`,
          { headers: { "Content-Type": "application/json" } }
        );
        const phoneStatus = response?.data?.phoneStatus;
        setIsPhoneUsed(phoneStatus);
        if (phoneStatus) {
          setErrorPhone(messages.errors.phoneExists);
        } else {
          setErrorPhone("");
        }
      } catch (error) {
        setErrorPhone(messages.errors.phoneValidationFailed);
      }
    }
  };

  const validatePhoneNumber = (phone) => {
    const parsedNumber = parsePhoneNumberFromString(phone);
    return parsedNumber ? parsedNumber.isValid() : false;
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleSignUp = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validateFirstName(firstname)) {
      setErrorFirstName(
        firstname.length > 0 && firstname.length < 3
          ? messages.errors.invalidFirstName
          : messages.errors.firstNameRequired
      );
      setLoading(false);
      return;
    }

    if (!validateLastName(lastname)) {
      setErrorLastName(
        lastname.length > 0 && lastname.length < 3
          ? messages.errors.invalidLastName
          : messages.errors.lastNameRequired
      );
      setLoading(false);
      return;
    }

    if (!validateEmail(email)) {
      setErrorEmail(
        email.length > 0
          ? messages.errors.invalidEmailFormat
          : messages.errors.emailRequired
      );
      setLoading(false);
      return;
    }

    if (!phone) {
      setErrorPhone(messages.errors.phoneRequired);
      setLoading(false);
      return;
    }

    if (!walletAddress) {
      setErrorWalletAddress(messages.errors.walletAddressRequired);
      setLoading(false);
      return;
    }

    if (!isValid) {
      setErrorPhone(messages.errors.invalidPhone);
      setLoading(false);
      return;
    }

    if (isPhoneUsed) {
      setErrorPhone(messages.errors.phoneExists);
      setLoading(false);
      return;
    }

    if (!isAccepted) {
      setErrorAcceptance(messages.errors.errorAcceptance);
      setLoading(false);
      return;
    }

    const userData = {
      firstname,
      lastname,
      phone,
      email,
      walletAddress,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/users/join-community`,
        userData
      )
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            title: messages.titles.success,
            text: messages.success.successJoinCommunity,
            icon: "success",
            confirmButtonText: messages.buttons.ok,
          });
          setLoading(false);
          setFirstName("");
          setLastName("");
          setPhone("");
          setEmail("");
          setWalletAddress("");
          setErrorFirstName("");
          setErrorLastName("");
          setErrorPhone("");
          setErrorEmail("");
          setErrorWalletAddress("");
          setIsAccepted(false);
          setErrorAcceptance("");
        } else {
          Swal.fire({
            title: messages.titles.error,
            text: `${response.data.message}`,
            icon: "error",
            confirmButtonText: messages.buttons.ok,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          title: messages.titles.error,
          text: messages.errors.somethingWentWrong,
          icon: "error",
          confirmButtonText: messages.buttons.ok,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const scrollToJoinCommunity = (targetElementId) => {
    const element = document.getElementById(targetElementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const hash = window.location.hash;
  if (hash) {
    const targetId = hash.substring(1);
    if (targetId) {
      scrollToJoinCommunity(targetId)
    }
  }
// newsletter start from here

useEffect(() => {
  getResponse();
}, [loadindNews])

const getResponse = () => {
  if (!loadindNews && success) {
    const successMessage = message || "Successfully signed up for the Newslatter.";
    Swal.fire({
      title: "Success!",
      text: successMessage,
      icon: "success",
      confirmButtonText: "Ok",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(resetNewsLetterState ());
      }
    })

    // Reset form fields after success
    setEmail("");
    setIsAccepted(false);
    setErrorEmail("");
    setErrorAcceptance("");

  } else if (!loadindNews && errorNews) {
    // Display the error message returned from the API
    const errorMessage = errorNews || "This email is already subscribed for Newsletter.";
    Swal.fire({
      title: "Error",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "Ok",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(resetNewsLetterState());
      }
    })

  }
}

const handleSubmit = (e) => {
  e.preventDefault();
  setErrorEmail("");
  setErrorAcceptance("");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) {
    // setErrorEmail("Email is required");
    Swal.fire({
      title: "Error",
      text: "Email is required!",
      icon: "error",
      confirmButtonText: "Ok",
    });
    return;
  } else if (!emailPattern.test(email)) {
    Swal.fire({
      title: "Success!",
      text: "Please enter a valid email address!",
      icon: "success",
      confirmButtonText: "Ok",
    });
    // setErrorEmail("Please enter a valid email address");
    // return;
  }

  if (!isAccepted) {
    Swal.fire({
      title: "Error",
      text: "You must accept the terms and conditions!",
      icon: "error",
      confirmButtonText: "Ok",
    });
    // setErrorAcceptance("You must accept the terms");
    return;
  }
  // Dispatch the signup action
  dispatch(signUpNewsLetter({ email, is_agree: isAccepted }));
};




//end here newsletter
  return (
    <>
      <div className="community_page">
        {/* <div className="ani-image-home">
          <img src={lineImage} alt="img" />
        </div> */}
        <div className="main-container-hero">
          <div className="ani-image-home">
            <img src={lineImage} alt="img" />
          </div>
          <div className="container main-page-containersection">
            <div className="match-detail-section">
              <div className="match-score-section">
                <table className="table-score">
                  {loading ? (
                    <div className="spinner-container">
                      <Spinner animation="border" variant="dark" size="xl" />
                    </div>
                  ) : (
                    <tbody>
                      {reversedPreviousGames
                        ?.slice(0, 10)
                        .map((match, index) => {
                          return (
                            <tr key={match?.id || index}>
                              <td>
                                <div className="team_score">
                                  <span
                                    className={`${
                                      match?.home_team_score <
                                      match?.visitor_team_score
                                        ? "loser"
                                        : "winner"
                                    }`}
                                  >
                                    {match?.home_team?.abbreviation}
                                    <span>
                                      {match?.home_team_score <
                                      match?.visitor_team_score
                                        ? "(L)"
                                        : "(W)"}
                                    </span>
                                  </span>

                                  <span
                                    className={`${
                                      match?.visitor_team_score <
                                      match?.home_team_score
                                        ? "loser"
                                        : "winner"
                                    }`}
                                  >
                                    {match?.visitor_team?.abbreviation}
                                    <span>
                                      {match?.visitor_team_score <
                                      match?.home_team_score
                                        ? "(L)"
                                        : "(W)"}
                                    </span>
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="team_score">
                                  <span
                                    className={`${
                                      match?.home_team_score <
                                      match?.visitor_team_score
                                        ? "loser"
                                        : "winner"
                                    }`}
                                  >
                                    <span>{match?.home_team_score}</span>
                                  </span>
                                  <span
                                    className={`${
                                      match?.visitor_team_score <
                                      match?.home_team_score
                                        ? "loser"
                                        : "winner"
                                    }`}
                                  >
                                    <span>{match?.visitor_team_score} </span>
                                  </span>
                                </div>
                              </td>

                              <td>
                                <div className="final-text">
                                  <div className="final-txt">
                                    {" "}
                                    {match?.period === 0
                                      ? "Postponed"
                                      : match?.status}
                                  </div>
                                  <div className="final-date">
                                    {new Intl.DateTimeFormat("en-US", {
                                      year: "numeric",
                                      month: "long",
                                      day: "numeric",
                                    }).format(
                                      new Date(
                                        new Date(match?.date).getTime() +
                                          86400000
                                      )
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  )}
                </table>
              </div>
              <div className="next-match-box">
                {loading ? (
                  <div className="spinner-container">
                    <Spinner animation="border" variant="dark" size="xl" />
                  </div>
                ) : (
                  <>
                    {isLive ? (
                      <>
                        <div className="live-icon">
                          <div class="circle"></div>
                          <span>Live</span>
                        </div>
                        <p className="next_txt">Live Match:</p>
                        {preScores?.lakers_data &&
                        preScores.lakers_data.length > 0 ? (
                          <>
                            <h3 className="match-date islivematch">
                              {formatDate(preScores.lakers_data[0].status)}
                            </h3>
                            <div className="match-time">
                              {isValidDate(preScores.lakers_data[0].status)
                                ? formatTime(preScores.lakers_data[0].status)
                                : preScores.lakers_data[0]?.status.replace(
                                    "Qtr",
                                    "Quarter"
                                  )}

                              {preScores.lakers_data[0].time &&
                              isValidTime(
                                preScores?.lakers_data[0]?.time?.split(" ")[1]
                              )
                                ? `, ${
                                    preScores?.lakers_data[0]?.time?.split(
                                      " "
                                    )[1] || preScores?.lakers_data[0]?.time
                                  }`
                                : preScores.lakers_data[0]?.time != undefined
                                ? `, ${preScores.lakers_data[0]?.time || ""}`
                                : null}
                            </div>
                            <div className="team-vs-match liveteam">
                              <span>
                                {
                                  preScores.lakers_data[0].visitor_team
                                    ?.abbreviation
                                }{" "}
                                {preScores.lakers_data[0].visitor_team?.standing
                                  ?.conference_rank !== undefined
                                  ? ` (${preScores.lakers_data[0].visitor_team.standing.conference_rank})`
                                  : ""}
                              </span>
                              <p>VS</p>
                              <span className="second-team">
                                {
                                  preScores.lakers_data[0].home_team
                                    ?.abbreviation
                                }{" "}
                                {preScores.lakers_data[0].home_team?.standing
                                  ?.conference_rank !== undefined
                                  ? ` (${preScores.lakers_data[0].home_team.standing.conference_rank})`
                                  : ""}
                              </span>
                            </div>
                            <div className="score final-score-bord">
                              <span>
                                {preScores.lakers_data[0].visitor_team_score}
                              </span>
                              <span>-</span>
                              <span>
                                {preScores.lakers_data[0].home_team_score}
                              </span>
                            </div>

                            <div className="score final-score-bord leaders-name">
                              <div className="row first-lead-tier">
                                {preScores.lakers_data[0].visitor_team.top_players?.map(
                                  (player, index) => (
                                    <span key={index}>
                                      <div className="main-playername">
                                        {player?.name}
                                      </div>
                                      <div className="player-points">
                                        {player?.point_details}
                                      </div>
                                      <div className="player-points player-score-percentage">
                                        {player?.percentage_details}
                                      </div>
                                    </span>
                                  )
                                )}
                              </div>
                              <div className="row second-lead-tier">
                                {preScores.lakers_data[0].home_team.top_players?.map(
                                  (player, index) => (
                                    <span key={index}>
                                      <div className="main-playername">
                                        {player?.name}
                                      </div>
                                      <div className="player-points">
                                        {player?.point_details}
                                      </div>
                                      <div className="player-points player-score-percentage">
                                        {player?.percentage_details}
                                      </div>
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <p>No live match data available.</p>
                        )}
                      </>
                    ) : (
                      <>
                        {preScores.lakers_data &&
                        preScores?.lakers_data.length > 0 &&
                        preScores?.lakers_data[0].time == "Final" ? (
                          <div className="final-score-datasection">
                            <p className="final-matchdata">Final</p>
                            <div className="team-vs-match final-team-names">
                              <span>
                                {
                                  preScores.lakers_data[0].visitor_team
                                    ?.abbreviation
                                }{" "}
                                {preScores.lakers_data[0].visitor_team_score <
                                preScores.lakers_data[0].home_team_score
                                  ? "(L)"
                                  : "(W)"}
                              </span>
                              <p>VS</p>
                              <span>
                                {
                                  preScores.lakers_data[0].home_team
                                    ?.abbreviation
                                }{" "}
                                {preScores?.lakers_data[0].home_team_score <
                                preScores.lakers_data[0].visitor_team_score
                                  ? "(L)"
                                  : "(W)"}
                              </span>
                            </div>
                            <div className="score final-score-bord final-team-score">
                              <span>
                                {preScores.lakers_data[0].visitor_team_score}{" "}
                              </span>
                              <span>-</span>
                              <span>
                                {preScores.lakers_data[0].home_team_score}{" "}
                              </span>
                            </div>
                          </div>
                        ) : null}

                        <p className="next_txt">
                          {hoursDifference < 2
                            ? "Upcoming Match:"
                            : "Next Match:"}
                        </p>
                        {first_upcoming_game ? (
                          <>
                            <h3 className="match-date">
                              {formatDate(first_upcoming_game.status)}
                            </h3>
                            <div className="match-time">
                              {formatTime(first_upcoming_game.status)}
                            </div>
                            <div className="team-vs-match">
                              <span>
                                {first_upcoming_game.visitor_team?.abbreviation}
                              </span>
                              <p>VS</p>
                              <span>
                                {first_upcoming_game.home_team?.abbreviation}
                              </span>
                            </div>
                            {/* Uncomment if you want to show scores for upcoming games */}
                            {/* <div className="score final-score-bord">
                <span>{first_upcoming_game.visitor_team_score}</span>
                <span>-</span>
                <span>{first_upcoming_game.home_team_score}</span>
              </div> */}
                          </>
                        ) : (
                          <p>No upcoming match data available.</p>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <TopStories />
        <PlayingGames />
        <div
          id="join-community"
          className="event-signupbox community-page-signuppage"
        >
          <div className="container community-header-hurry-up ">
            <h2>Subscribe for the Newsletter! </h2>
          </div>
          <div className="home-container home-page centercontainer ">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="laker-fan-coin-form event-lakerform">
                <form onSubmit={handleSubmit}>
                  <h3>Please, Sign Up for the Newsletter</h3>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="form-box">
                        <label htmlFor="email">
                          Email<span className="color-asterisk">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrorEmail("");
                          }}
                          maxLength={40}
                        />
                        <span className="fa-solid fa-envelope field-icon"></span>
                      </div>
                      {errorEmail && (
                        <div className="validation-mess">
                          <p className="text-danger">{errorEmail}</p>
                        </div>
                      )}
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="accept-content">
                        <div className="accept-checkbox">
                          <input
                            type="checkbox"
                            id="acceptance"
                            checked={isAccepted}
                            onChange={(e) => {
                              setIsAccepted(e.target.checked);
                              setErrorAcceptance("");
                            }}
                          />
                        </div>
                        <div>
                          <label htmlFor="acceptance">
                            By joining the LFCoin Community, you agree that $LAL
                            coins are promotional and not linked to any other
                            offers or obligations. They hold no guaranteed
                            value, and $LAL is not liable for any losses or
                            issues arising from receiving or using the coins. No
                            legal claims or recourse will be accepted.
                          </label>
                        </div>
                      </div>
                      {errorAcceptance && (
                        <div className="validation-mess">
                          <p className="text-danger">{errorAcceptance}</p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="cstm-login-btn">
                    <button
                      type="submit"
                      className="btn w-100"
                      disabled={loadindNews}
                    >
                      {loadindNews ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <div id="join-community" className="container community-header-hurry-up mt-4">
          <h2>Join our community now to claim your airdrop!</h2>
        </div>
        <div className="home-container home-page centercontainer">
          <div className="col-lg-6 col-md-12 col-sm-12  signup-forairdrop">
            <div className="laker-fan-coin-form">
              <form onSubmit={handleSignUp}>
                <h3>Sign up to Join Our Community</h3>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-box">
                      <label htmlFor="firstName">
                        First Name<span className="color-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        name="firstName"
                        placeholder="First Name"
                        value={firstname}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (validateNoNumbersOrSpecialChars(inputValue)) {
                            const capitalizedValue =
                              capitalizeFirstLetter(inputValue);
                            setFirstName(capitalizedValue);
                            setErrorFirstName("");
                          } else {
                            setErrorFirstName(
                              "Only alphabet characters are allowed."
                            );
                          }
                        }}
                        maxLength={16}
                      />
                      <span className="fa-solid fa-user field-icon"></span>
                    </div>
                    {errorFirstName && (
                      <div className="validation-mess">
                        <p className="text-danger">{errorFirstName}</p>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="form-box">
                      <label htmlFor="lastName">
                        Last Name<span className="color-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        name="lastName"
                        placeholder="Last Name"
                        value={lastname}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (validateNoNumbersOrSpecialChars(inputValue)) {
                            const capitalizedValue =
                              capitalizeFirstLetter(inputValue);
                            setLastName(capitalizedValue);
                            setErrorLastName("");
                          } else {
                            setErrorLastName(
                              "Only alphabet characters are allowed."
                            );
                          }
                        }}
                        maxLength={16}
                      />
                      <span className="fa-solid fa-user field-icon"></span>
                    </div>
                    {errorLastName && (
                      <div className="validation-mess">
                        <p className="text-danger">{errorLastName}</p>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-box">
                      <label htmlFor="email">
                        Email<span className="color-asterisk">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setErrorEmail("");
                        }}
                        maxLength={40}
                      />
                      <span className="fa-solid fa-envelope field-icon"></span>
                    </div>
                    {errorEmail && (
                      <div className="validation-mess">
                        <p className="text-danger">{errorEmail}</p>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="custom-phone-input">
                      <label htmlFor="phone">
                        Phone<span className="color-asterisk">*</span>
                      </label>
                      <PhoneInput
                        country={"us"}
                        value={phone}
                        className="form-control"
                        onChange={(value, country) => {
                          handleChange(value, country);
                        }}
                        inputProps={{
                          required: true,
                          placeholder: "Enter phone number",
                        }}
                      />
                      <span className="fa-solid fa-phone field-icon"></span>
                    </div>
                    {errorPhone && (
                      <div className="validation-mess">
                        <p className="text-danger">{errorPhone}</p>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-box">
                      <label htmlFor="walletAddress" className="wallet-airdrop">
                        Solana Wallet Address
                        <span className="color-asterisk">*</span>
                      </label>
                      <input
                        type="string"
                        className="form-control"
                        id="walletAddress"
                        name="Wallet Address"
                        placeholder="Solana Wallet Address"
                        value={walletAddress}
                        onChange={(e) => {
                          setWalletAddress(e.target.value);
                          setErrorWalletAddress("");
                        }}
                        maxLength={65}
                      />
                    </div>
                    {errorWalletAddress && (
                      <div className="validation-mess">
                        <p className="text-danger">{errorWalletAddress}</p>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div style={{ display: "flex", marginTop: "8px" }}>
                      <div style={{ marginRight: "10px", marginTop: "4px" }}>
                        <input
                          type="checkbox"
                          id="acceptance"
                          checked={isAccepted}
                          onChange={(e) => {
                            setIsAccepted(e.target.checked);
                            setErrorAcceptance("");
                          }}
                        />
                      </div>
                      <div>
                        <label htmlFor="acceptance">
                          By joining the LFCoin Community, you agree that $LAL
                          coins are promotional and not linked to any other
                          offers or obligations. They hold no guaranteed value,
                          and $LAL is not liable for any losses or issues
                          arising from receiving or using the coins. No legal
                          claims or recourse will be accepted.
                        </label>
                      </div>
                    </div>
                    {errorAcceptance && (
                      <div className="validation-mess">
                        <p className="text-danger">{errorAcceptance}</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="cstm-login-btn">
                  <button
                    type="submit"
                    className="btn w-100"
                    disabled={loadingData}
                  >
                    {loadingData ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default CommunityPageMain;
